import {Typography} from '@mui/material'
import React from 'react'

interface DisplayValueProps {
  value: string
  unit: string
  onValueClick: () => void
  'data-test-id'?: string
}

/**
 * Display component for showing the formatted quantity value with unit.
 * Private component used internally by QuantityInput.
 */
export const QuantityDisplayValue: React.FC<DisplayValueProps> = ({
  value,
  unit,
  onValueClick,
  'data-test-id': dataTestId
}) => {
  const formattedValue = `${value} ${unit.toUpperCase()}`

  return (
    <Typography
      onClick={onValueClick}
      sx={{
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '24px',
        color: '#29333d',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        userSelect: 'none'
      }}
      data-test-id={dataTestId}
    >
      {formattedValue}
    </Typography>
  )
}
